<template>
  <InputComponent
    v-bind="$attrs"
    :class="{ 'custom-fields-radio--has-icon': itemsHasIcon }"
    class="custom-fields-radio"
  >
    <RadioComponent v-model="comp" v-bind="$attrs" :items="items" class="elder-input__element">
      <template v-if="itemsHasIcon" v-slot:label="{ item }">
        <span class="custom-fields-radio__content">
          <span
            :class="{ 'custom-fields-radio__icon--selected': comp === item.value }"
            class="custom-fields-radio__icon"
          >
            <Icon :icon="item.icon" size="2x" />
          </span>
          <span class="custom-fields-radio__label"> {{ item.label }}</span>
        </span>
      </template>
    </RadioComponent>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import RadioComponent from '@kvass/radio'
import Icon from '@kvass/vue2-icon'

import { ValueComp } from '../utils'

export default {
  props: ['value', 'default'],
  computed: {
    comp: ValueComp(),

    itemsHasIcon() {
      return (this.$attrs.items || []).some(i => i.icon)
    },

    items() {
      if (!this.$attrs.disabled) return this.$attrs.items
      return this.$attrs.items.map(v => {
        return {
          ...v,
          disabled: true,
        }
      })
    },
  },
  created() {
    if ('default' in this.$options.propsData && this.value === undefined) this.comp = this.default
  },
  components: {
    InputComponent,
    RadioComponent,
    Icon,
  },
}
</script>

<style lang="scss">
.custom-fields-radio {
  &--has-icon {
    .elder-input__field {
      border: none;
    }

    .elder-input__element {
      padding: 1rem 0 0;
    }

    .kvass-radio {
      &__wrapper {
        position: relative;
        align-items: start;
        flex-direction: reverse;
        width: 100%;
        margin: 0;

        & > div:not(.kvass-radio__radio) {
          width: 100%;
        }
      }

      &__radio {
        position: absolute;
        left: 0;
      }
    }

    .custom-fields-radio {
      &__content {
        width: 100%;
        grid-area: label;

        display: flex;
        flex-direction: column-reverse;
        gap: 1rem;
        align-items: center;
      }
      &__label {
        font-weight: bold;
        margin-right: auto;
        margin-left: 2.5rem;
      }

      &__icon {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 2rem;
        border-radius: var(--vue-elder-border-radius, 3px);
        border: 1px solid var(--primary);

        &--selected {
          background-color: var(--secondary);
        }
      }
    }
  }
}
</style>
